import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_parent,
  add_parent,
  update_parent,
  delete_parent,
  get_parent_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  parent: [],
  parentlist:[],
  school_id:"",
  student_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    email :"",
    relation :"",
    mobile_no :"",
    address :"",
    profession :"",
  },
};

// Async Thunks for API Calls
export const fetchparentlist = createAsyncThunk(
    'parent/fetchparentlist',
    async ({school_id,student_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_parent_list(school_id,student_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchparent = createAsyncThunk(
  "parent/fetchparent",
  async ({ page, page_size,school_id,student_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_parent(page, page_size,school_id,student_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createparent = createAsyncThunk(
  "parent/createparent",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_parent(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateparent = createAsyncThunk(
  "parent/updateparent",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_parent(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteparent = createAsyncThunk(
  "parent/deleteparent",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_parent({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// parent Slice
const parentSlice = createSlice({
  name: 'parents',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, 
        name,
        email ,
        relation ,
        mobile_no ,
        address ,
        profession } = action.payload;
      state.formData = { id,
        name,
        email ,
        relation ,
        mobile_no ,
        address ,
        profession  };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        email :"",
        relation :"",
        mobile_no :"",
        address :"",
        profession :"",
      };
    },
    setParent(state, action) {
      state.parent = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
    setStudentId(state, action) {
        state.student_id = action.payload;
      },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchparentlist.fulfilled, (state, action) => {
        state.parentlist = action.payload.data;
      })
       // Fetch parent
       .addCase(fetchparent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchparent.fulfilled, (state, action) => {
        state.loading = false;
        state.parent = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchparent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add parent
      .addCase(createparent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createparent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.parent = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createparent.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update parent
      .addCase(updateparent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateparent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateparent.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete parent
      .addCase(deleteparent.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteparent.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteparent.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setParent,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = parentSlice.actions;
export default parentSlice.reducer;
